module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("tabs__content " + (!_vm.isActive ? 'tabs__content--hidden' : '')),
    attrs: {
      "data-content": _vm.id
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71414abe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab.vue
// module id = 1055
// module chunks = 1